module.exports = __webpack_public_path__ + "static/media/redcap.37b5486e.webp";